var _path, _path2, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46875 0H16.1312C20.1174 0 23.35 3.07862 23.35 6.875V15.125C23.35 18.9214 20.1174 22 16.1312 22H7.46875C3.48256 22 0.25 18.9214 0.25 15.125V6.875C0.25 3.07862 3.48256 0 7.46875 0ZM16.1312 19.9375C18.9177 19.9375 21.1844 17.7787 21.1844 15.125V6.875C21.1844 4.22125 18.9177 2.0625 16.1312 2.0625H7.46875C4.68231 2.0625 2.41562 4.22125 2.41562 6.875V15.125C2.41562 17.7787 4.68231 19.9375 7.46875 19.9375H16.1312Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.02502 11C6.02502 7.96263 8.61078 5.5 11.8 5.5C14.9893 5.5 17.575 7.96263 17.575 11C17.575 14.0374 14.9893 16.5 11.8 16.5C8.61078 16.5 6.02502 14.0374 6.02502 11ZM8.19065 11C8.19065 12.8948 9.81054 14.4375 11.8 14.4375C13.7895 14.4375 15.4094 12.8948 15.4094 11C15.4094 9.10388 13.7895 7.5625 11.8 7.5625C9.81054 7.5625 8.19065 9.10388 8.19065 11Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.0081,
    cy: 5.08749,
    rx: 0.769519,
    ry: 0.732875,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.e4bad1bc7f7c8c056636d31b5003feb7.svg";
export { ForwardRef as ReactComponent };